import { AutogenLayoutOffice941TotalsReport } from "./autogen/AutogenLayoutOffice941TotalsReport";

export class Office941TotalsReport extends AutogenLayoutOffice941TotalsReport {

    override onLoad(): void {
        super.onLoad();
        // Set focus to the date range field when the report loads
        this.textboxDateRange.focus();
    }
}
